export default __webpack_public_path__ + "static/media/user_teachers.13f891da.svg";